import React from "react"

const HeroSection: React.FC = () => {
  return (
    <section className="w-full max-w-[1699px] h-[300px] sm:h-[400px] md:h-[500px] lg:h-[650px] xl:h-[810px] mx-auto">
      <div className="w-full h-full">
        <img
          src="/web-ttmi/menu/menu-thu-duc/menu-overview.png"
          alt="Thực Đơn Mỹ Thực - Overview"
          className="w-full h-full object-cover"
        />
      </div>
    </section>
  )
}

export default HeroSection
